module.exports = __webpack_public_path__ + "img/dots_lub_4.66e4fc62.png";